export const statsData = [
  { number: '500+', label: '工业企业客户' },
  { number: '35%', label: '平均综合节能率' },
  { number: '99.9%', label: '系统实时可用性' },
  { number: '12', label: '能碳管理中心功能' },
];

export const energyFeaturesData = [
  {
    icon: 'ri-search-eye-line',
    title: '能耗查询',
    description: '多维度能耗数据查询与追溯，支持按时间、区域、设备、产线等任意维度灵活检索，一键导出原始数据报表，满足内部审计与合规需求。',
    href: '/dashboard',
  },
  {
    icon: 'ri-bar-chart-2-line',
    title: '能源消费量和强度计算',
    description: '自动计算电、气、热、水等各类能源消费总量，同步核算单位产值能源强度与万元GDP能耗，生成趋势分析图表，实时对比目标指标。',
    href: '/dashboard',
  },
  {
    icon: 'ri-line-chart-line',
    title: '能源消费分析与用能策略推荐',
    description: 'AI 深度分析能源消费结构与用能规律，识别异常高耗能环节，智能推荐峰谷优化、设备调参、工序调度等节能策略，平均节能 15-30%。',
    href: '#ai',
  },
  {
    icon: 'ri-award-line',
    title: '能效对标',
    description: '对标行业先进能效基准与国家能耗限额标准，定位企业能效差距，生成对标分析报告，为绿色工厂、能源管理体系认证提供数据支撑。',
    href: '/solutions/manufacturing',
  },
  {
    icon: 'ri-flow-chart',
    title: '能流分析',
    description: '可视化呈现工厂全链路能量流向，从外网输入到末端设备逐层展示能量传递路径与损耗，精准识别能耗高损节点，指导节能改造方向。',
    href: '/dashboard',
  },
  {
    icon: 'ri-equalizer-line',
    title: '能效平衡与优化',
    description: 'AI 实时监测供需能效平衡状态，自动调度多能源系统协同运行，最优分配能源载荷，在保障生产稳定的前提下实现能源利用效率最大化。',
    href: '#ai',
  },
];

export const carbonFeaturesData = [
  {
    icon: 'ri-funds-box-line',
    title: '用能与碳排放预算管理',
    description: '年度/季度/月度分层级制定能源与碳排放总量预算，实时追踪预算执行进度，超预算自动预警，支持滚动修订与部门分解考核。',
    href: '/solutions/manufacturing',
  },
  {
    icon: 'ri-calculator-line',
    title: '碳排放核算',
    description: '按照国家发改委与生态环境部碳核算指南，自动核算范围一、范围二全部碳排放，支持 IPCC、GHG Protocol 多标准体系，合规报告一键生成。',
    href: '#ai',
  },
  {
    icon: 'ri-footprint-line',
    title: '产品碳足迹核算',
    description: '全生命周期产品碳足迹 LCA 核算，覆盖原材料采购、生产制造、物流运输全阶段，支持 ISO 14067 标准，为 CBAM 申报与绿色供应链认证提供数据。',
    href: '/solutions/manufacturing',
  },
  {
    icon: 'ri-links-line',
    title: '供应链碳管理',
    description: '量化上下游供应商范围三间接排放，建立供应链碳排放数据库，联合减排方案协同推进，帮助企业满足国际买家绿色采购要求与 SBTi 目标。',
    href: '/solutions/manufacturing',
  },
  {
    icon: 'ri-shield-check-line',
    title: '碳核查支撑',
    description: '全程记录碳排放原始数据与计算过程，生成完整审计轨迹，提供符合第三方核查机构要求的核查证明材料包，支持 MRV 体系全流程配合。',
    href: '#ai',
  },
  {
    icon: 'ri-stock-line',
    title: '碳资产管理',
    description: '统一管理配额、CCER 等各类碳资产，实时监控持仓价值与交易窗口，AI 辅助碳资产买卖时机决策，帮助企业降低履约成本、盘活碳资产价值。',
    href: '/solutions/manufacturing',
  },
];

// Keep old featuresData for backward compatibility if needed, pointing to merged list
export const featuresData = [...energyFeaturesData, ...carbonFeaturesData];

export const dashboardFeatures = [
  {
    icon: 'ri-flashlight-line',
    title: '毫秒级数据更新',
    description: '传感器数据实时同步，延迟低于100ms',
  },
  {
    icon: 'ri-server-line',
    title: '多设备统一监控',
    description: '支持电、水、气、热等多能源类型统一管理',
  },
  {
    icon: 'ri-alarm-warning-line',
    title: '自定义告警规则',
    description: '灵活配置告警阈值与通知方式，精准触达',
  },
];

export const casesData = [
  {
    logo: 'https://readdy.ai/api/search-image?query=modern%20manufacturing%20factory%20building%20exterior%20with%20solar%20panels%20on%20roof%20clean%20industrial%20architecture%20blue%20sky%20professional%20corporate%20photography&width=200&height=80&seq=case1&orientation=landscape',
    result: '节能 32%',
    metric: '年节约电费 860万元',
    quote: 'Firmai平台帮助我们实现了全厂能源的精细化管理，AI预测性维护功能让设备故障率降低了60%。',
    name: '张明华',
    title: '能源管理总监',
    company: '华能精密制造集团',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20male%20business%20executive%20portrait%20headshot%20wearing%20suit%20confident%20smile%20clean%20background%20corporate%20photography&width=60&height=60&seq=avatar1&orientation=squarish',
  },
  {
    logo: 'https://readdy.ai/api/search-image?query=modern%20logistics%20warehouse%20distribution%20center%20with%20automated%20systems%20clean%20organized%20interior%20professional%20corporate%20photography&width=200&height=80&seq=case2&orientation=landscape',
    result: '减排 5000吨/年',
    metric: '碳排放降低 28%',
    quote: '通过Firmai的碳排放追踪功能，我们成功获得了绿色供应链认证，客户满意度显著提升。',
    name: '李雪婷',
    title: '可持续发展负责人',
    company: '顺丰智慧物流',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20female%20business%20executive%20portrait%20headshot%20wearing%20blazer%20confident%20smile%20clean%20background%20corporate%20photography&width=60&height=60&seq=avatar2&orientation=squarish',
  },
  {
    logo: 'https://readdy.ai/api/search-image?query=modern%20commercial%20office%20building%20with%20glass%20facade%20green%20landscaping%20urban%20architecture%20professional%20corporate%20photography&width=200&height=80&seq=case3&orientation=landscape',
    result: '效率提升 45%',
    metric: '运维成本降低 35%',
    quote: '钉钉集成功能让我们的能源报告自动推送到管理层，决策效率大幅提升，真正实现了数字化管理。',
    name: '王建国',
    title: '运营副总裁',
    company: '万科商业地产',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20male%20senior%20executive%20portrait%20headshot%20wearing%20glasses%20suit%20confident%20clean%20background%20corporate%20photography&width=60&height=60&seq=avatar3&orientation=squarish',
  },
];

export const blogData = [
  {
    slug: '2025-energy-management-trends',
    image: 'https://readdy.ai/api/search-image?query=futuristic%20smart%20city%20with%20green%20energy%20infrastructure%20wind%20turbines%20solar%20panels%20digital%20overlay%20holographic%20data%20visualization%20dark%20background%20professional%20tech%20illustration&width=400&height=240&seq=blog1&orientation=landscape',
    category: '行业趋势',
    date: '2025.04.15',
    title: '2025年企业能源管理十大趋势：AI驱动下的智能化转型',
    excerpt: '随着碳中和目标的推进，企业能源管理正经历前所未有的变革。本文深入分析AI、物联网和大数据如何重塑能源管理格局...',
  },
  {
    slug: 'predictive-maintenance-revolution',
    image: 'https://readdy.ai/api/search-image?query=industrial%20IoT%20sensors%20and%20smart%20meters%20connected%20in%20network%20digital%20data%20flow%20green%20glowing%20lines%20dark%20background%20professional%20tech%20illustration&width=400&height=240&seq=blog2&orientation=landscape',
    category: '技术洞察',
    date: '2025.04.08',
    title: '预测性维护：从被动维修到主动预防的能源设备管理革命',
    excerpt: '传统设备维护模式已无法满足现代工业需求。基于机器学习的预测性维护技术正在改变这一现状...',
  },
  {
    slug: 'carbon-footprint-accounting-guide',
    image: 'https://readdy.ai/api/search-image?query=carbon%20footprint%20tracking%20dashboard%20with%20green%20leaf%20icons%20data%20charts%20environmental%20metrics%20dark%20background%20professional%20tech%20illustration&width=400&height=240&seq=blog3&orientation=landscape',
    category: '碳中和',
    date: '2025.03.28',
    title: '企业碳足迹核算实战指南：从数据采集到报告生成',
    excerpt: '碳足迹核算是企业实现碳中和的第一步。本文提供一套完整的实操方法论，帮助企业建立科学的碳管理体系...',
  },
];

export const integrationTools = [
  { name: '钉钉', icon: 'ri-message-3-line' },
  { name: '飞书', icon: 'ri-chat-1-line' },
  { name: '企业微信', icon: 'ri-wechat-fill' },
  { name: 'Slack', icon: 'ri-slack-line' },
  { name: 'Teams', icon: 'ri-microsoft-fill' },
];

export const solutionsData = [
  {
    id: 'digital-energy',
    icon: 'ri-building-4-line',
    title: '工业企业能碳中心',
    subtitle: '数字化能碳管理中心建设',
    description: 'Firmai 依据工信部《工业企业和园区数字化能碳管理中心建设指南》，为制造业企业提供涵盖 12 项核心功能的一体化能碳管理平台，助力企业通过能碳中心建设评估。',
    features: [
      '能耗查询与多维度数据展示',
      '能源消费量/强度自动计算',
      'AI 用能策略智能推荐',
      '能效对标与行业基准分析',
      '能流可视化分析',
      '用能与碳排放预算管控',
    ],
    image: 'https://readdy.ai/api/search-image?query=modern%20industrial%20smart%20factory%20interior%20with%20digital%20energy%20management%20screens%20IoT%20sensors%20monitoring%20equipment%20green%20technology%20automation%20professional%20photography%20clean%20bright&width=500&height=350&seq=solution1b&orientation=landscape',
    statValue: '300+',
    statLabel: '工业企业落地',
  },
  {
    id: 'park-carbon',
    icon: 'ri-community-line',
    title: '工业园区碳管理',
    subtitle: '园区级碳排放统一管控',
    description: '面向工业园区，提供园区级碳排放统一核算与管理，整合入园企业能源与碳数据，支持园区碳达峰路径规划、低碳园区认定申报与碳中和目标管理。',
    features: [
      '园区多企业碳排汇总核算',
      '入园企业碳排放在线监测',
      '产品碳足迹与供应链碳管理',
      '碳核查全流程数据支撑',
      '碳资产统一管理与交易',
      '低碳/零碳园区申报辅导',
    ],
    image: 'https://readdy.ai/api/search-image?query=aerial%20view%20modern%20industrial%20park%20with%20green%20spaces%20solar%20panels%20smart%20energy%20infrastructure%20sustainable%20development%20professional%20photography%20clear%20day&width=500&height=350&seq=solution2b&orientation=landscape',
    statValue: '50+',
    statLabel: '园区标杆项目',
  },
  {
    id: 'ccer-asset',
    icon: 'ri-exchange-dollar-line',
    title: 'CCER 碳资产开发',
    subtitle: '温室气体自愿减排量变现',
    description: '依托 Firmai 精准碳排放数据，协助企业开发 CCER 项目，支持直连全国温室气体自愿减排注册登记系统完成申报，将减排成果转化为可交易碳资产。',
    features: [
      'CCER 方法学匹配与项目设计',
      '减排量自动核算与数据准备',
      '监测计划制定与系统直连申报',
      '项目备案与签发全程管理',
      '碳配额 + CCER 资产统一管理',
      'AI 辅助碳资产交易决策',
    ],
    image: 'https://readdy.ai/api/search-image?query=carbon%20credit%20trading%20digital%20concept%20with%20green%20leaf%20data%20charts%20currency%20symbols%20financial%20technology%20dark%20background%20professional%20tech%20illustration%20modern&width=500&height=350&seq=solution3b&orientation=landscape',
    statValue: '50+',
    statLabel: 'CCER 项目备案',
  },
];

export const footerLinks = {
  product: [
    { label: '实时监测', href: '#' },
    { label: 'AI分析', href: '#' },
    { label: '预测维护', href: '#' },
    { label: '碳排放追踪', href: '#' },
    { label: '智能报告', href: '#' },
  ],
  solutions: [
    { label: '制造业', href: '#' },
    { label: '物流仓储', href: '#' },
    { label: '商业地产', href: '#' },
    { label: '数据中心', href: '#' },
    { label: '公共事业', href: '#' },
  ],
  resources: [
    { label: '行业洞察', href: '#' },
    { label: '技术文档', href: '#' },
    { label: '帮助中心', href: '#' },
    { label: 'API文档', href: '#' },
    { label: '更新日志', href: '#' },
  ],
};